import {
  ACTION_GET_BOOKING,
  ACTION_GET_BOOKING_SUCCESS,
  ACTION_GET_BOOKING_FAILURE,
  ACTION_EMPTY_BOOKING,
  ACTION_POST_BOOKING_NEW_PAYMENT_SUCCESS,
  ACTION_POST_REFUND_BOOKING_SUCCESS,
  ACTION_PUT_BOOKINGS_CUSTOM_TAG,
  ACTION_PUT_BOOKINGS_CUSTOM_TAG_SUCCESS,
  ACTION_PUT_BOOKINGS_CUSTOM_TAG_FAILURE,
  ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE,
  ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_SUCCESS,
  ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_FAILURE,
  ACTION_PUT_CANCEL_BOOKING_SUCCESS,
  ACTION_PUT_UPDATE_BOOKING_SUCCESS,
  ACTION_POST_BOOKING_FLIGHTCREDITS_SUCCESS,
  ACTION_POST_BOOKING_FLIGHTCREDITS,
  ACTION_REDEEM_CRC_POINTS_SUCCESS,
} from '../configs/ActionTypes';

import * as _ from 'lodash-es';

const initialState = {
  booking: null,
  isLoading: false,
  success: null,
};

export default function (state = initialState, action: any) {
  switch (action.type) {
    case ACTION_GET_BOOKING:
    case ACTION_PUT_BOOKINGS_CUSTOM_TAG:
    case ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE: {
      return {
        ...state,
        isLoading: true,
      };
    }

    case ACTION_GET_BOOKING_SUCCESS: {
      const b = action.payload.payload;

      let booking: any = b;

      return {
        ...state,
        isLoading: false,
        booking: booking,
        success: true,
      };
    }

    case ACTION_POST_BOOKING_NEW_PAYMENT_SUCCESS:
    case ACTION_POST_REFUND_BOOKING_SUCCESS: {
      let booking = state.booking as any;
      _.set(
        booking,
        'transactions',
        _.get(action.payload.payload, 'transactions', []),
      );

      return {
        ...state,
        booking: booking,
      };
    }

    case ACTION_PUT_BOOKINGS_CUSTOM_TAG_SUCCESS: {
      let booking: any = _.clone(state.booking);
      const tagsId = action.payload.payload.tags;
      let tags = _.get(booking, 'possibleTags', []).filter((obj: any) =>
        tagsId.includes(obj.id),
      );

      booking.tags = tags;

      return {
        ...state,
        booking,
        isLoading: false,
        success: true,
      };
    }

    case ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_SUCCESS: {
      return {
        ...state,
        booking: {
          ...state.booking,
          customFields: action.payload?.payload ?? [],
        },
        isLoading: false,
        success: true,
      };
    }

    case ACTION_GET_BOOKING_FAILURE:
    case ACTION_PUT_BOOKINGS_CUSTOM_TAG_FAILURE:
    case ACTION_PUT_BOOKINGS_CUSTOM_FIELD_RESPONSE_FAILURE: {
      return {
        ...state,
        success: false,
        isLoading: false,
      };
    }

    case ACTION_EMPTY_BOOKING: {
      return initialState;
    }

    case ACTION_PUT_CANCEL_BOOKING_SUCCESS: {
      let booking: any = state.booking;
      _.set(booking, 'status', 'canceled');

      return {
        ...state,
        booking,
      };
    }
    case ACTION_POST_BOOKING_FLIGHTCREDITS: {
      return {
        ...state,
        attemptedFlightCreditAdd: true,
      };
    }

    case ACTION_POST_BOOKING_FLIGHTCREDITS_SUCCESS: {
      const ticketNumber: string = action.payload.payload.ticketNumber;
      const booking: any = state.booking;
      _.set(booking, 'flightCreditRecord.ticketNumber', ticketNumber);
      return {
        ...state,
        booking,
      };
    }

    case ACTION_PUT_UPDATE_BOOKING_SUCCESS: {
      const payload = action.payload.payload;
      if (!state.booking || !payload) return state;

      // Build a new booking object (immutable update — never mutate state directly).
      let booking: any = { ...state.booking };

      if (payload.confirmationNumber !== undefined) booking.confirmationNumber = payload.confirmationNumber;
      if (payload.status !== undefined) booking.status = payload.status;
      if (payload.notes !== undefined) booking.notes = payload.notes;

      // Only apply pricing/date fields that are explicitly present in the response.
      const mergeableFields = [
        'basePrice',
        'taxPrice',
        'totalPrice',
        'customerPrice',
        'requiredCharges',
        'providerReturnDate',
        'arrivalDate',
        'departureDate',
        'checkInTime',
        'checkOutTime',
        'endDate',
        'dropOffDate',
      ];
      for (const field of mergeableFields) {
        if (Object.prototype.hasOwnProperty.call(payload, field)) {
          booking[field] = payload[field];
        }
      }

      if (payload.type === 'hotel' || booking.type === 'hotel') {
        if (payload.basePrice !== undefined) booking.basePrice = payload.basePrice;
        if (payload.totalPrice !== undefined) booking.totalPrice = payload.totalPrice;
        if (payload.customerPrice !== undefined) booking.customerPrice = payload.customerPrice;

        const existingHotel = booking.hotel ?? {};
        const responseHotel = payload.hotel ?? {};
        const { roomDetails: responseRoomDetails, ...responseHotelFields } = responseHotel;
        const hotelAddress = payload.hotelAddress ?? {};
        const hasHotelUpdate = Object.keys(responseHotel).length > 0 ||
          payload.hotelName !== undefined || Object.keys(hotelAddress).length > 0 ||
          payload.roomType !== undefined || payload.bedType !== undefined ||
          payload.cancellationPolicy !== undefined || payload.cancelationPolicy !== undefined;

        if (hasHotelUpdate) {
          const existingRooms = Array.isArray(existingHotel.roomDetails)
            ? existingHotel.roomDetails
            : [];
          const responseRooms = Array.isArray(responseRoomDetails)
            ? responseRoomDetails
            : [];
          const responseFirstRoom = responseRooms[0] ?? {};
          const hasFirstRoomUpdate = Object.keys(responseFirstRoom).length > 0 ||
            payload.roomType !== undefined || payload.bedType !== undefined ||
            payload.cancellationPolicy !== undefined || payload.cancelationPolicy !== undefined;
          const roomDetails = hasFirstRoomUpdate
            ? [
                {
                  ...(existingRooms[0] ?? {}),
                  ...responseFirstRoom,
                  ...(payload.roomType !== undefined && { roomDescription: payload.roomType }),
                  ...(payload.bedType !== undefined && { bedDescription: payload.bedType }),
                  ...(payload.cancellationPolicy !== undefined && { cancelationPolicy: payload.cancellationPolicy }),
                  ...(payload.cancelationPolicy !== undefined && { cancelationPolicy: payload.cancelationPolicy }),
                },
                ...existingRooms.slice(1),
              ]
            : existingRooms;

          booking.hotel = {
            ...existingHotel,
            ...responseHotelFields,
            ...(payload.hotelName !== undefined && { name: payload.hotelName }),
            ...(hotelAddress.street !== undefined && { address: hotelAddress.street }),
            ...(hotelAddress.city !== undefined && { city: hotelAddress.city }),
            ...(hotelAddress.state !== undefined && { stateProvinceCode: hotelAddress.state }),
            ...(hotelAddress.countryCode !== undefined && { countryCode: hotelAddress.countryCode }),
            ...(hotelAddress.postalCode !== undefined && { postalCode: hotelAddress.postalCode }),
            ...(hasFirstRoomUpdate && { roomDetails }),
          };
        }
      }

      if (payload.type === 'flight' && payload.segments && booking.segments) {
        let currentSegmentCounter = 0;
        const newSegments = booking.segments.map((segmentGroup: any) => {
          const segment = segmentGroup.segment.map((singleSegment: any) => {
            currentSegmentCounter++;
            return { ...payload.segments[currentSegmentCounter - 1] };
          });
          return {
            ...segmentGroup,
            from: segment?.[0]?.from,
            to: segment?.[segment.length - 1]?.to,
            segment,
          };
        });
        booking.segments = newSegments;
      }

      return {
        ...state,
        booking,
      };
    }

    case ACTION_REDEEM_CRC_POINTS_SUCCESS: {
      const transaction = action.payload.payload;
      const booking: any = { ...state.booking };
      booking.transactions = [...(booking.transactions || []), transaction];
      return {
        ...state,
        booking,
      };
    }

    default: {
      return state;
    }
  }
}
